import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { SERIES_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'

export default function SeriesPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${SERIES_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
